export const countriesList = [
    { "Code": "AF", "Name": "Afghanistan" },
    { "Code": "AX", "Name": "Aland Islands" },
    { "Code": "AL", "Name": "Albania" },
    { "Code": "DZ", "Name": "Algeria" },
    { "Code": "AS", "Name": "American Samoa" },
    { "Code": "AD", "Name": "Andorra" },
    { "Code": "AO", "Name": "Angola" },
    { "Code": "AI", "Name": "Anguilla" },
    { "Code": "AQ", "Name": "Antarctica" },
    { "Code": "AG", "Name": "Antigua and Barbuda" },
    { "Code": "AR", "Name": "Argentina" },
    { "Code": "AM", "Name": "Armenia" },
    { "Code": "AW", "Name": "Aruba" },
    { "Code": "AU", "Name": "Australia" },
    { "Code": "AT", "Name": "Austria" },
    { "Code": "AZ", "Name": "Azerbaijan" },
    { "Code": "BS", "Name": "Bahamas" },
    { "Code": "BH", "Name": "Bahrain" },
    { "Code": "BD", "Name": "Bangladesh" },
    { "Code": "BB", "Name": "Barbados" },
    { "Code": "BY", "Name": "Belarus" },
    { "Code": "BE", "Name": "Belgium" },
    { "Code": "BZ", "Name": "Belize" },
    { "Code": "BJ", "Name": "Benin" },
    { "Code": "BM", "Name": "Bermuda" },
    { "Code": "BT", "Name": "Bhutan" },
    { "Code": "BO", "Name": "Bolivia" },
    { "Code": "BA", "Name": "Bosnia and Herzegovina" },
    { "Code": "BW", "Name": "Botswana" },
    { "Code": "BV", "Name": "Bouvet Island" },
    { "Code": "BR", "Name": "Brazil" },
    { "Code": "IO", "Name": "British Indian Ocean Territory" },
    { "Code": "BN", "Name": "Brunei Darussalam" },
    { "Code": "BG", "Name": "Bulgaria" },
    { "Code": "BF", "Name": "Burkina Faso" },
    { "Code": "BI", "Name": "Burundi" },
    { "Code": "KH", "Name": "Cambodia" },
    { "Code": "CM", "Name": "Cameroon" },
    { "Code": "CA", "Name": "Canada" },
    { "Code": "IC", "Name": "Canary Islands" },
    { "Code": "CV", "Name": "Cape Verde" },
    { "Code": "KY", "Name": "Cayman Island" },
    { "Code": "KY", "Name": "Cayman Islands" },
    { "Code": "CF", "Name": "Central African Republic" },
    { "Code": "TD", "Name": "Chad" },
    { "Code": "JE", "Name": "Channel Island (Jersey)" },
    { "Code": "GG", "Name": "Channel Islands(Guernsey)" },
    { "Code": "CL", "Name": "Chile" },
    { "Code": "CN", "Name": "China" },
    { "Code": "CX", "Name": "Christmas Island" },
    { "Code": "CC", "Name": "Cocos (Keeling) Islands" },
    { "Code": "CO", "Name": "Colombia" },
    { "Code": "KM", "Name": "Comoros" },
    { "Code": "CG", "Name": "Congo" },
    { "Code": "CD", "Name": "Congo Democratic (Zaire)" },
    { "Code": "CK", "Name": "Cook Islands and Rarotonga" },
    { "Code": "CR", "Name": "Costa Rica" },
    { "Code": "CI", "Name": "Cote D'ivoire" },
    { "Code": "HR", "Name": "Croatia" },
    { "Code": "CU", "Name": "Cuba" },
    { "Code": "CW", "Name": "Curacao" },
    { "Code": "CY", "Name": "Cyprus" },
    { "Code": "CZ", "Name": "Czech Republic" },
    { "Code": "DK", "Name": "Denmark" },
    { "Code": "IO", "Name": "Diego Garcia and Chagos Archip" },
    { "Code": "DJ", "Name": "Djibouti" },
    { "Code": "DM", "Name": "Dominica Commonwealth" },
    { "Code": "DO", "Name": "Dominican Republic" },
    { "Code": "EC", "Name": "Ecuador and Galapagos Island" },
    { "Code": "EG", "Name": "Egypt" },
    { "Code": "SV", "Name": "El Salvador" },
    { "Code": "GQ", "Name": "Equatorial Guinea" },
    { "Code": "ER", "Name": "Eritrea" },
    { "Code": "EE", "Name": "Estonia" },
    { "Code": "ET", "Name": "Ethiopia" },
    { "Code": "FO", "Name": "Faeroe Islands" },
    { "Code": "FK", "Name": "Falkland Islands (Malvinas)" },
    { "Code": "FJ", "Name": "Fiji Islands" },
    { "Code": "FI", "Name": "Finland" },
    { "Code": "FR", "Name": "France" },
    { "Code": "FR", "Name": "France- Metropolitan" },
    { "Code": "XX", "Name": "Free Zone" },
    { "Code": "GF", "Name": "French Guiana" },
    { "Code": "PF", "Name": "French Polynesia - Tahiti,Gamb" },
    { "Code": "TF", "Name": "French Southern Territories -" },
    { "Code": "GA", "Name": "Gabon" },
    { "Code": "GM", "Name": "Gambia" },
    { "Code": "GE", "Name": "Georgia" },
    { "Code": "DE", "Name": "Germany" },
    { "Code": "GH", "Name": "Ghana" },
    { "Code": "GI", "Name": "Gibraltar" },
    { "Code": "GB", "Name": "Great Britain" },
    { "Code": "GR", "Name": "Greece" },
    { "Code": "GL", "Name": "Greenland" },
    { "Code": "GD", "Name": "Grenada" },
    { "Code": "GP", "Name": "Guadeloupe" },
    { "Code": "GU", "Name": "Guam" },
    { "Code": "GT", "Name": "Guatemala" },
    { "Code": "GG", "Name": "Guernsey" },
    { "Code": "GN", "Name": "Guinea" },
    { "Code": "GW", "Name": "Guinea-Bissau" },
    { "Code": "GY", "Name": "Guyana" },
    { "Code": "HT", "Name": "Haiti" },
    { "Code": "HM", "Name": "Heard and McDonald Islands" },
    { "Code": "HU", "Name": "Hengharia" },
    { "Code": "VA", "Name": "Holy See-Vatican City State" },
    { "Code": "HN", "Name": "Honduras" },
    { "Code": "HK", "Name": "Hong Kong" },
    { "Code": "HU", "Name": "Hungary" },
    { "Code": "IS", "Name": "Iceland" },
    { "Code": "IN", "Name": "India" },
    { "Code": "ID", "Name": "Indonesia" },
    { "Code": "IQ", "Name": "Iraq" },
    { "Code": "IE", "Name": "Ireland" },
    { "Code": "IR", "Name": "Islamic Republic Of Iran" },
    { "Code": "IM", "Name": "Isle of Man" },
    { "Code": "IL", "Name": "Israel" },
    { "Code": "IT", "Name": "Italy" },
    { "Code": "CI", "Name": "Ivory Coast" },
    { "Code": "JM", "Name": "Jamaica" },
    { "Code": "JP", "Name": "Japan" },
    { "Code": "JE", "Name": "Jersey" },
    { "Code": "JO", "Name": "Jordan" },
    { "Code": "KZ", "Name": "Kazakhstan" },
    { "Code": "KE", "Name": "Kenya" },
    { "Code": "SA", "Name": "Kingdom of Saudi Arabia" },
    { "Code": "KI", "Name": "Kiribati" },
    { "Code": "KW", "Name": "Kuwait" },
    { "Code": "KG", "Name": "Kyrgyzstan" },
    { "Code": "LA", "Name": "Laos" },
    { "Code": "LV", "Name": "Latvia" },
    { "Code": "LB", "Name": "Lebanon" },
    { "Code": "LS", "Name": "Lesotho" },
    { "Code": "LR", "Name": "Liberia" },
    { "Code": "LY", "Name": "Libya" },
    { "Code": "LI", "Name": "Liechtenstein" },
    { "Code": "LT", "Name": "Lithuania" },
    { "Code": "LU", "Name": "Luxembourg" },
    { "Code": "MO", "Name": "Macao" },
    { "Code": "MK", "Name": "Macedonia" },
    { "Code": "MG", "Name": "Madagascar" },
    { "Code": "MW", "Name": "Malawi" },
    { "Code": "MY", "Name": "Malaysia" },
    { "Code": "ML", "Name": "Mali" },
    { "Code": "MT", "Name": "Malta" },
    { "Code": "IM", "Name": "Man (Isle of)" },
    { "Code": "MH", "Name": "Marshall Islands" },
    { "Code": "MQ", "Name": "Martinique" },
    { "Code": "MR", "Name": "Mauritania" },
    { "Code": "MU", "Name": "Mauritius" },
    { "Code": "YT", "Name": "Mayotte" },
    { "Code": "MX", "Name": "Mexico" },
    { "Code": "FM", "Name": "Micronesia Federated" },
    { "Code": "UM", "Name": "Minor Outlying Islands - Midwa" },
    { "Code": "MD", "Name": "Moldova" },
    { "Code": "MD", "Name": "Moldova, Republic of" },
    { "Code": "MC", "Name": "Monaco" },
    { "Code": "MN", "Name": "Mongolia" },
    { "Code": "ME", "Name": "Montenegro" },
    { "Code": "MS", "Name": "Montserrat" },
    { "Code": "MA", "Name": "Morocco" },
    { "Code": "MZ", "Name": "Mozambique" },
    { "Code": "MM", "Name": "Myanmar" },
    { "Code": "NA", "Name": "Namibia" },
    { "Code": "NR", "Name": "Nauru" },
    { "Code": "NP", "Name": "Nepal" },
    { "Code": "NL", "Name": "Netherlands" },
    { "Code": "NL", "Name": "Netherlands Antilles" }, //AN
    { "Code": "NC", "Name": "New Caledonia" },
    { "Code": "NZ", "Name": "New Zealand" },
    { "Code": "NI", "Name": "Nicaragua" },
    { "Code": "NE", "Name": "Niger" },
    { "Code": "NG", "Name": "Nigeria" },
    { "Code": "NU", "Name": "Niue" },
    { "Code": "NF", "Name": "Norfolk island" },
    { "Code": "KP", "Name": "North Korea" },
    { "Code": "MP", "Name": "Northern Mariana Islands & Sai" },
    { "Code": "NO", "Name": "Norway" },
    { "Code": "KI", "Name": "Pacific Islands and Kiribati" },
    { "Code": "PK", "Name": "Pakistan" },
    { "Code": "PW", "Name": "Palau and Babelthuap" },
    { "Code": "PS", "Name": "Palestine" },
    { "Code": "PA", "Name": "Panama" },
    { "Code": "PG", "Name": "Papua New Guinea" },
    { "Code": "PY", "Name": "Paraguay" },
    { "Code": "PE", "Name": "Peru" },
    { "Code": "PH", "Name": "Philippines" },
    { "Code": "PN", "Name": "Pitcairn" },
    { "Code": "PL", "Name": "Poland" },
    { "Code": "PT", "Name": "Portugal" },
    { "Code": "PR", "Name": "Puerto Rico" },
    { "Code": "MV", "Name": "Republic Of Maldives" },
    { "Code": "UZ", "Name": "Republic Of Uzbekistan" },
    { "Code": "YE", "Name": "Republic Of Yemen" },
    { "Code": "CG", "Name": "Republic of Congo" },
    { "Code": "XK", "Name": "Republic of Kosovo" },
    { "Code": "RE", "Name": "Reunion" },
    { "Code": "RO", "Name": "Romania" },
    { "Code": "RU", "Name": "Russia" },
    { "Code": "RU", "Name": "Russian Federation" },
    { "Code": "RW", "Name": "Rwanda" },
    { "Code": "SH", "Name": "Saint Helena, Ascension and Tr" },
    { "Code": "KN", "Name": "Saint Kitts and Nevis" },
    { "Code": "LC", "Name": "Saint Lucia" },
    { "Code": "SH", "Name": "Sainte Helena - Ascension , Go" },
    { "Code": "WS", "Name": "Samoa" },
    { "Code": "SM", "Name": "San Marino" },
    { "Code": "ST", "Name": "Sao Tome and Principe" },
    { "Code": "SN", "Name": "Senegal" },
    { "Code": "RS", "Name": "Serbia" },
    { "Code": "ME", "Name": "Serbia and Montenegro" }, //CS
    { "Code": "SC", "Name": "Seychelles" },
    { "Code": "SL", "Name": "Sierra Leone" },
    { "Code": "SG", "Name": "Singapore" },
    { "Code": "SK", "Name": "Slovakia-Slovak Republic" },
    { "Code": "SI", "Name": "Slovenia" },
    { "Code": "SB", "Name": "Solomon Islands" },
    { "Code": "SB", "Name": "Solomon Islands and Guadalcana" },
    { "Code": "SO", "Name": "Somalia" },
    { "Code": "ZA", "Name": "South Africa" },
    { "Code": "GS", "Name": "South Georgia and South Sandwi" },
    { "Code": "KR", "Name": "South Korea" },
    { "Code": "SS", "Name": "South Sudan" },
    { "Code": "ES", "Name": "Spain" },
    { "Code": "LK", "Name": "Sri Lanka" },
    { "Code": "SH", "Name": "St. Helena" },
    { "Code": "KN", "Name": "St.Christopher (St.Kitts) & Ne" },
    { "Code": "LC", "Name": "St.Lucia" },
    { "Code": "PM", "Name": "St.Pierre and Miquelon" },
    { "Code": "VC", "Name": "St.Vincent and Grenadines" },
    { "Code": "QA", "Name": "State of Qatar" },
    { "Code": "SD", "Name": "Sudan" },
    { "Code": "OM", "Name": "Sultanate of Oman" },
    { "Code": "SR", "Name": "Suriname" },
    { "Code": "SJ", "Name": "Svalbard and Jan Mayen" },
    { "Code": "SZ", "Name": "Swaziland" },
    { "Code": "SE", "Name": "Sweden" },
    { "Code": "CH", "Name": "Switzerland" },
    { "Code": "SY", "Name": "Syria" },
    { "Code": "GR", "Name": "THE HELLENIC REPBL" },
    { "Code": "GR", "Name": "THE HELLENIC REPBL (Greece)" },
    { "Code": "TW", "Name": "Taiwan" },
    { "Code": "TJ", "Name": "Tajikistan" },
    { "Code": "TZ", "Name": "Tanzania" },
    { "Code": "TH", "Name": "Thailand" },
    { "Code": "TL", "Name": "Timor-Leste" },
    { "Code": "TG", "Name": "Togo" },
    { "Code": "TK", "Name": "Tokelau" },
    { "Code": "TO", "Name": "Tonga" },
    { "Code": "ZA", "Name": "Transkei" },
    { "Code": "TT", "Name": "Trinidad and Tobago" },
    { "Code": "TN", "Name": "Tunisia" },
    { "Code": "TR", "Name": "Turkey" },
    { "Code": "TR", "Name": "Turkiye" },
    { "Code": "TM", "Name": "Turkmenistan" },
    { "Code": "TC", "Name": "Turks and Caicos" },
    { "Code": "TV", "Name": "Tuvalu and Funafuti" },
    { "Code": "GB", "Name": "UNK" },
    { "Code": "UG", "Name": "Uganda" },
    { "Code": "UA", "Name": "Ukraine" },
    { "Code": "AE", "Name": "United Arab Emirates" },
    { "Code": "GB", "Name": "United Kingdom" },
    { "Code": "UM", "Name": "United States Minor Outlying I" },
    { "Code": "US", "Name": "United States of America" },
    { "Code": "XX", "Name": "Unknown" },
    { "Code": "UY", "Name": "Uruguay" },
    { "Code": "VU", "Name": "Vanuatu" },
    { "Code": "VE", "Name": "Venezuela" },
    { "Code": "VN", "Name": "Vietnam" },
    { "Code": "VG", "Name": "Virgin Islands(UK)" },
    { "Code": "VI", "Name": "Virgin Islands(USA)" },
    { "Code": "UM", "Name": "Wake-Islands" },
    { "Code": "WF", "Name": "Wallis and Futuna" },
    { "Code": "EH", "Name": "Western Sahara" },
    { "Code": "WS", "Name": "Western Samoa" },
    { "Code": "YE", "Name": "Yemen" },
    { "Code": "XX", "Name": "Yugoslavia" },
    { "Code": "ZM", "Name": "Zambia" },
    { "Code": "ZW", "Name": "Zimbabwe" }
]
